import { Center, Container, Stack, Title, Text, Button } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
    return (
        <Center style={{ minHeight: '100vh' }}>
            <Container size="sm">
                <Stack align="center" gap="md">
                    <Title order={1} fz={72} fw={700}>
                        404
                    </Title>
                    <Text c="dimmed">Страница не найдена.</Text>
                    <Button component={Link} to="/" variant="light">
                        На главную
                    </Button>
                </Stack>
            </Container>
        </Center>
    );
}
